import { post } from "@selector/shared";
import type { components } from "@selector/shared/openapi";

export type CreateGroupRequest = components["schemas"]["CreateGroupRequest"];

export async function saveGroup(metadata: CreateGroupRequest) {
  const { data } = await post("/group", undefined, undefined, metadata);
  return data;
}
